export default function displayCurrency(
  value: string,
  symbol: string,
  position: 'before' | 'after' = 'before',
) {
  if (position === 'before') {
    return `${symbol}${value}`;
  }
  return `${value} ${symbol}`;
}
